import { Paper } from '@mui/material'
import { useEffect } from 'react'
import { REWARDS_TABS } from '../../../components/navigation'
import { NavTabs, useNavTabs } from '../../../components/navigation/NavTabs'
import { useStoreActions, useStoreState } from '../../../store/hooks'
import { RewardClaimed } from '../components/rewards/ClaimRewardAnimation'
import { GuestBlocker } from '../components/rewards/GuestBlocker'
import { RewardsAchievements } from './RewardsAchievements'
import { RewardsChallenges } from './RewardsChallenges'

const REWARDS_CONTENT = {
    [REWARDS_TABS.MISSIONS]: <RewardsChallenges />,
    [REWARDS_TABS.ACHIEVEMENTS]: <RewardsAchievements />,
}

export const Rewards = () => {
    const getRewards = useStoreActions((state) => state.rewardsService.getRewards)
    const isCompletedChallenges = useStoreState((state) => state.rewardsService.isCompletedChallenges)
    const { currentTab } = useNavTabs(REWARDS_TABS)

    // const achievements = useStoreState((state) => state.rewardsService.achievements)
    const badges = {
        [REWARDS_TABS.MISSIONS]: isCompletedChallenges,
    }

    useEffect(() => {
        getRewards()
    }, [])

    return (
        <>
            <NavTabs tabs={REWARDS_TABS} badges={badges} />
            <Paper
                sx={{
                    display: 'flex',
                    padding: 0,
                    '> div': {
                        padding: 1.5,
                    },
                    flexGrow: 1,
                    overflowY: 'auto',
                    position: 'relative',
                    height: { xs: 'calc(100dvh - 366px)', sm: 'calc(100dvh - 326px)', md: 'unset' },
                    minHeight: { xs: '300px', md: 'unset' },
                }}
                variant="outlined"
            >
                {REWARDS_CONTENT[currentTab]}
                <GuestBlocker />
            </Paper>
            <RewardClaimed />
        </>
    )
}
